/**
 * La face de `<Checkbox>`, par état : pure (aucun Unistyles), pour que `theme/contrast.test.ts` mesure la
 * case telle qu'elle se peint, dans les quatre thèmes.
 *
 * Cochée, la case prend l'aplat d'une option choisie (`role-selected` : l'orange du bouton chez l'élève,
 * le marine chez le parent), cerné de la couleur de l'univers, et la coche s'y pose dans l'encre de cet
 * aplat. Non cochée, un contour seul,
 * à l'encre secondaire. Une case cochée ne se dit donc plus par un carré plein de la couleur de son
 * contour, où la coche disparaissait (daily du 23/10, « Ma lecture » : une option cochée ne se voyait
 * pas cochée — le glyphe plein recouvrait sa propre coche).
 */
import type { SemanticColorKey } from "../../theme/tokens/colors"

export type CheckboxFace = {
    /** Le fond de la case ; `null` : transparent, la surface qui la porte. */
    fill: SemanticColorKey | null
    border: SemanticColorKey
    /** La coche ; `null` : pas de coche. */
    check: SemanticColorKey | null
}

export const CHECKBOX_FACES: Record<"unchecked" | "checked", CheckboxFace> = {
    unchecked: { fill: null, border: "text-muted", check: null },
    // Le liseré à l'orange d'affichage : l'aplat seul ne tient que 2,5:1 sur un encart de la nuit de
    // l'élève, son liseré 3,4:1 (`contrast.test.ts`). Chez le parent, c'est le même marine.
    checked: { fill: "role-selected", border: "role", check: "text-on-role" },
}

/** Les surfaces où une case se pose : une carte ou une feuille, la page, un encart. */
export const CHECKBOX_SURFACES: SemanticColorKey[] = ["surface-raised", "surface", "surface-subtle"]
